// Use to format JSON date strings serialized from MVC in /Date(xxxxx)/ format
angular.module('filters.jsonDate', [])
    .filter('jsonDate', function ($filter) {
        return function (input, format) {
            return $filter('date')(parseInt(input.replace(/\/Date\((.*?)\)\//gi, "$1")), format);
        };
    });